// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2SaZr","validationTips":"StatementDescriptor_validationTips__2BZW9"};